import { Variants } from 'framer-motion';

/**
 * GLOBAL ANIMATION CONSTANTS
 */
export const ANIMATION_SPEED = 0.3;
export const ANIMATION_DELAY = 0;

export const selectedCardDesktopVariants: Variants = {
    start: {
        position: 'absolute',
        left: 1000 / 2 - 210,
        top: 0,
    },
    show: {
        left: 0,
        position: 'inherit',
    },
    close: {
        borderRadius: '14px',
        width: '100%',
    },

    initUpsellCard: {
        opacity: 0,
        zIndex: 4,
    },
    displayUpsellCard: {
        opacity: 1,
        right: 21,
        left: 21,
        bottom: 0,
    },
    initOptions: {
        opacity: 0,
    },
    displayOptions: {
        opacity: 1,
    },

    initButtons: {
        opacity: 0,
    },
    displayButtons: {
        opacity: 1,
    },
};

export const selectedCardMobileVariants: Variants = {
    start: {
        position: 'absolute',
        top: 130,
        left: 0,
        right: 0,
        bottom: 0,
        borderRadius: '14px 14px 0 0',
        zIndex: 5,
    },
    // Takes the card out of the absolute/full-overlay "start" position so content
    // rendered after it (upsell copy, upsell/options cards) is no longer hidden
    // underneath it. Mirrors "close"'s position:'initial' hand-off, but keeps the
    // card full-width rather than collapsing it to a compact inset card.
    show: {
        left: 0,
        right: 0,
        borderRadius: '14px',
        transitionEnd: {
            height: 'auto',
            position: 'initial',
        },
    },
    close: {
        left: 21,
        right: 21,
        height: 260,
        borderRadius: '14px',
        transitionEnd: {
            height: 'auto',
            position: 'initial',
        },
    },

    initUpsellCard: {
        opacity: 0,
        zIndex: 4,
    },
    displayUpsellCard: {
        opacity: 1,
        right: 21,
        left: 21,
        bottom: 0,
    },
    openUpsellCard: {
        zIndex: 6,
        position: 'absolute',
        backgroundColor: 'var(--rs-theme)',
        color: 'var(--rs-highlight)',
        bottom: 0,
        left: 0,
        right: 0,
        top: 160,
        opacity: 1,
    },

    initOptions: {
        opacity: 0,
    },
    displayOptions: {
        opacity: 1,
    },

    initButtons: {
        opacity: 0,
    },
    displayButtons: {
        opacity: 1,
    },
};

/**
 * DEAL PAGE ANIMATIONS
 */
export const dealCardVariants: Variants = {
    initSelectedCard: {
        position: 'absolute',
        top: 81,
        left: 0,
        right: 0,
        bottom: 0,
        borderRadius: '14px 14px 0 0',
        zIndex: 5,
    },
    closeSelectedCard: {
        left: 21,
        right: 21,
        height: 260,
        borderRadius: '14px',
        transitionEnd: {
            height: 'auto',
            position: 'initial',
        },
    },

    initUpsellCard: {
        opacity: 0,
        zIndex: 4,
    },
    displayUpsellCard: {
        opacity: 1,
        right: 21,
        left: 21,
        bottom: 0,
    // position: 'absolute'
    },
    openUpsellCard: {
        zIndex: 6,
        position: 'absolute',
        backgroundColor: 'var(--rs-theme)',
        color: 'var(--rs-highlight)',
        bottom: 0,
        left: 0,
        right: 0,
        top: 160,
        opacity: 1,
    },

    initOptions: {
        opacity: 0,
    },
    displayOptions: {
        opacity: 1,
    },

    initButtons: {
        opacity: 0,
    },
    displayButtons: {
        opacity: 1,
    },
};

export const dealCardVariantsDesktop: Variants = {
    initSelectedCard: {
        position: 'absolute',
        left: 1000 / 2 - 210,
        top: 0,
    },
    displaySelectedCard: {
        left: 0,
        position: 'inherit',
    },
    closeSelectedCard: {
        borderRadius: '14px',
        width: '100%',
    },

    initUpsellCard: {
        opacity: 0,
        zIndex: 4,
    },
    displayUpsellCard: {
        opacity: 1,
        right: 21,
        left: 21,
        bottom: 0,
    },
    initOptions: {
        opacity: 0,
    },
    displayOptions: {
        opacity: 1,
    },

    initButtons: {
        opacity: 0,
    },
    displayButtons: {
        opacity: 1,
    },
};

export const contactVariants: Variants[] = [
    {
        initial: {
            opacity: 0,
            display: 'none',
            zIndex: -999,
        },
        start: {
            opacity: 1,
            zIndex: 50,
            display: 'flex',
        },
        fadeOut: {
            opacity: 0,
        },
    },
    {
        initial: {
            opacity: 0,
            display: 'none',
            padding: '22px',
        },
        start: {
            opacity: 1,
            display: 'block',
            padding: '22px',
        },
        fadeOut: {
            opacity: 0,
        },
    },
];

export const optionsCardVariants: Variants = {
    start: {
        opacity: 0,
    },
    show: {
        opacity: 1,
    },
};

export const cardButtonsVariants: Variants = {
    start: {
        opacity: 0,
        display: 'none',
    },
    show: {
        opacity: 1,
        display: 'block',
    },
};
